export default __webpack_public_path__ + "static/media/YAS0370.34I-29775_-23415_0.b25f9ca3.jpg";